import { useEffect } from "react";
import "./oneWord.css";
import { input } from "../../helper";
import Question from "../Question";
import { TextField } from "../TextField";

export default function OneWord({
  color = "",
  data,
  number,
  correctAnswer,
  setCorrectAnswer,
}) {

  //Empty the input when a new data is rendered
  useEffect(() => {
    setCorrectAnswer("");
    const inputs = document.querySelector(".question-fields .field-input");
    inputs.innerHTML = "";
  }, [number]);

  return (
    <Question
      color={color}
      index={number}
      label={"Answer in one word"}
      question={data}
    >
      <TextField
        id={"op1"}
        style={input(color)}
        value={correctAnswer}
        onChange={(value) => {
          console.log(value);
          setCorrectAnswer(value)
        }}
      />
      {/*<textarea
        placeholder="Write your answer here"
        style={input(color)}
        onChange={handleChange}
      ></textarea>*/}
    </Question>
  );
}
